import { MessageType } from '../../shared/constants';
import { UserAlertDTO } from '../../shared/DTO/UserAlertsDTO';
import { MessageDTO } from '../../shared/DTO/MessageDTO';
import { DatePipe } from '@angular/common';

export class Message {
    isSelected = false;
    opened = false;
    firstRead: boolean;

    constructor(private pkid: string,
        private title: string,
        private text: string,
        private date: Date,
        private isRead: boolean,
        private type: MessageType) {
        this.firstRead = !isRead;
    }

    static fromUserAlertDto(userAlertDTO: UserAlertDTO): Message {
      userAlertDTO.PKID = userAlertDTO['msgId'];
      userAlertDTO.Title = userAlertDTO['title'];
      userAlertDTO.Text = userAlertDTO['message'];
      userAlertDTO.Date = new Date(userAlertDTO['messageDate']);
      userAlertDTO.IsRead = userAlertDTO['isRead'];
      return new Message(userAlertDTO.PKID,
          userAlertDTO.Title,
          userAlertDTO.Text,
          userAlertDTO.Date,
          userAlertDTO.IsRead,
          userAlertDTO.messageType === 'alert' ? MessageType.ALERT : MessageType.MESSAGE
      );
    }

    static fromMessageDto(messageDTO: MessageDTO): Message {
        return new Message(messageDTO.msgId.toString(),
            messageDTO.Title,
            messageDTO.Message,
            messageDTO.MessageDate,
            messageDTO.IsRead === 1,
            MessageType.ALERT
        );
    }

    getPkid(): string {
        return this.pkid;
    }

    getType(): MessageType {
        return this.type;
    }

    isMessage(): boolean {
        return this.type === MessageType.MESSAGE;
    }

    isAlert(): boolean {
        return this.type === MessageType.ALERT;
    }

    getDate(): Date {
        return this.date;
    }

    getIsRead(): boolean {
        return this.isRead;
    }

    setIsRead(isRead: boolean): void {
        this.isRead = isRead;
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/messages/messages.model.ts